import { BestSuggestedFunds } from "@/type/commonTypes";
import { OverlapSchemes } from "@/type/overlapType";

export function filterSchemes(schemes: OverlapSchemes[], search: string, excludeId?: number): OverlapSchemes[] {
  return schemes.filter((s) => {
    const matchesSearch = s.scheme_name.toLowerCase().includes(search.toLowerCase());

    const notExcluded = excludeId ? s.id !== excludeId : true;

    return matchesSearch && notExcluded;
  });
}

const SCALE_STEPS = [2, 5, 10, 20, 30, 50, 80, 100] as const;

export const getScaleBase = (value: number): number => {
  for (const step of SCALE_STEPS) {
    if (value <= step) return step;
  }
  return SCALE_STEPS[SCALE_STEPS.length - 1];
};

export function getShortAndLongTermFunds(funds: BestSuggestedFunds[]) {
  const sortedByYear = [...funds].sort((a, b) => (Number(b.sc_one_year_returns) || 0) - (Number(a.sc_one_year_returns) || 0));

  const sortedByMonth = [...funds].sort((a, b) => (Number(b.sc_one_month_returns) || 0) - (Number(a.sc_one_month_returns) || 0));

  const longTerm = sortedByYear[0] || null;

  let shortTerm = sortedByMonth[0] || null;

  if (longTerm && shortTerm && longTerm.id === shortTerm.id) {
    shortTerm = sortedByMonth[1] || null;
  }

  return {
    longTerm,
    shortTerm,
  };
}

export function calculateGrowthSectorScore(sector: BestSuggestedFunds): number {
  const oneWeek = Number(sector.one_weak_abs);
  const oneMonth = Number(sector.one_month_abs);
  const threeMonth = Number(sector.three_month_abs);
  const sixMonth = Number(sector.six_month_abs);

  const baseScore = oneWeek * 0.1 + oneMonth * 0.2 + threeMonth * 0.3 + sixMonth * 0.4;

  let bonus = 0;
  let penalty = 0;

  // Acceleration bonus
  if (oneMonth > threeMonth) {
    bonus += 0.5;
  }

  if (oneWeek > oneMonth) {
    bonus += 0.5;
  }
  // Negative 6M penalty
  if (sixMonth < 0) {
    penalty += 1;
  }

  // Weak short + medium term penalty
  if (threeMonth < 0 && oneMonth < 0) {
    penalty += 1;
  }

  return Number((baseScore + bonus - penalty).toFixed(4));
}

export function rankSectors(data: BestSuggestedFunds[]) {
  return data
    .map((sector) => ({
      ...sector,
      score: calculateGrowthSectorScore(sector),
    }))
    .sort((a, b) => b.score - a.score);
}
